<template>
   <vs-td>
      <div class="device-info">
        <div class="shadow-drop d-theme-dark-bg cursor-pointer round px-3 py-2" v-if="status">
          <iconOnOff :width="16" :height="16" iconColor="#EA5455" class="align-middle"/>
        </div>
        <div class="shadow-drop d-theme-dark-bg cursor-pointer round px-3 py-2" v-else>
          <iconOnOff :width="16" :height="16" iconColor="#28C76F" class="align-middle"/>
        </div>
        <div class="device-text-container">
          <span class="main-info" v-if="status">{{messageTrue != undefined ? messageTrue :$t("Messages.On")}}</span>
          <span class="main-info" v-else>{{messageFalse != undefined ? messageFalse :$t("Messages.Off")}}</span>
          <span class="subtext-info" v-if="name" :class="classDescription">{{name}}</span>
        </div>
      </div>
    </vs-td>
</template>
<script>
import iconOnOff from '@/components/icons/iconOnOff'

export default {
  components: {
    iconOnOff
  },
  props: {
    status: Boolean,
    messageTrue: String,
    messageFalse: String,
    name: String,
    classDescription: {
      type: String,
      default: ''
    }
  }
}
</script>
